import { createLocalStorage } from '@/services/storage/storage-service';

const KEY = 'SHIPPING_VALUES';

export class ShippingStorage {
  constructor(storage = createLocalStorage()) {
    this.storage = storage;
  }

  setValues({ totalPrice, shippingPrice, shippingGroupsCount }) {
    this.storage.setItem(KEY, { totalPrice, shippingPrice, shippingGroupsCount });
  }

  getValues() {
    return this.storage.getItem(KEY) || [];
  }
}

export const createShippingStorage = () => new ShippingStorage();
